function toLocalIsoDate(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function fromIsoDate(value: string) {
  return new Date(`${value}T00:00:00`);
}

export function todayIso(date = new Date()) {
  return toLocalIsoDate(date);
}

export function addDaysIso(days: number, from = new Date()) {
  const date = new Date(from);
  date.setDate(date.getDate() + days);
  return toLocalIsoDate(date);
}

export function countCompletionsThisWeek(completions: string[], today: string) {
  const weekStart = fromIsoDate(today);
  const day = weekStart.getDay();
  const daysSinceMonday = (day + 6) % 7;
  weekStart.setDate(weekStart.getDate() - daysSinceMonday);

  const nextWeekStart = new Date(weekStart);
  nextWeekStart.setDate(nextWeekStart.getDate() + 7);

  return Array.from(new Set(completions)).filter((completion) => {
    const date = fromIsoDate(completion);
    return date >= weekStart && date < nextWeekStart;
  }).length;
}

export function isWithinDays(value: string, start: string, days: number) {
  const date = fromIsoDate(value);
  const startDate = fromIsoDate(start);
  const endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + days);

  return date >= startDate && date <= endDate;
}

export function formatMoney(value: number) {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDate(value: string) {
  return new Intl.DateTimeFormat("vi-VN", {
    day: "2-digit",
    month: "2-digit",
  }).format(new Date(`${value}T00:00:00`));
}
